import React from 'react';
import { WHATSAPP_URL } from './constants';
export function FloatingMobileCta() {
  return <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="fixed inset-x-0 bottom-0 z-50 block bg-[#1B2B4A] px-6 py-4 text-center text-base font-medium text-white shadow-[0_-4px_20px_rgba(0,0,0,0.35)] sm:hidden" data-id="element-38">
      💬 Hablar ahora · $10.000 · 24/7
    </a>;
}